import folderStore from 'owa-folders';
import { isUnderDistinguishedFolder } from 'owa-folders';
import { ARCHIVE_FOLDER_ROOT_DISTINGUISHED_ID, ARCHIVE_DUMPSTER_DISTINGUISHED_ID, } from 'owa-folders';
/**
 * @param folderId - Id of folder for which we are checking
 * @param state - state of folder table if passed from the caller(optional)
 * @returns boolean - true if folder is found under archive mailbox root
 */
export default function isFolderUnderArchiveRoot(folderId, state) {
    var folder = folderStore.folderTable.get(folderId);
    return folder
        ? isUnderDistinguishedFolder(folder, ARCHIVE_FOLDER_ROOT_DISTINGUISHED_ID, state) ||
            folder.DistinguishedFolderId === ARCHIVE_DUMPSTER_DISTINGUISHED_ID
        : false;
}
/**
 * @param folderId - Id of folder for which we are checking
 * @returns boolean - true if folder is archive mailbox root
 */
export function isArchiveRootFolder(folderId) {
    var folder = folderStore.folderTable.get(folderId);
    return folder && folder.distinguishedFolderId === ARCHIVE_FOLDER_ROOT_DISTINGUISHED_ID;
}
/**
 * @param folderId - Id of folder for which we are checking
 * @returns boolean - true if folder is archive root or a subfolder of archive root
 */
export function isFolderOrSubFolderOfArchiveRoot(folderId) {
    return isFolderUnderArchiveRoot(folderId) || isArchiveRootFolder(folderId);
}
//# sourceMappingURL=isFolderUnderArchiveRoot.js.map